import React, { useCallback } from "react";
import { Box, Stack, Avatar, IconButton, CircularProgress } from "@mui/material";
import { Send } from "@mui/icons-material";
import { MentionsInput, Mention } from "react-mentions";
import { mentionsStyleComments } from "./mentionsStyles";
import CommentItem from "./CommentItem"; // Importamos el sub-componente

const PostCommentsSection = (props) => {
  const handleDataFetch = useCallback(
    (query, callback) => {
      if (typeof props.queryUsers === "function") {
        props.queryUsers(query, callback);
      } else {
        callback([]);
      }
    },
    [props.queryUsers]
  );

  const handleMainSubmit = () => {
    const text = props.mainCommentText;
    if (text && text.trim() !== "") {
      props.onCommentSubmit(text);
    }
  };

  return (
    <Box sx={{ bgcolor: "#fff", p: 2, borderTop: "1px solid #eee" }}>
      {props.loading ? (
        <CircularProgress size={20} sx={{ display: "block", mx: "auto", my: 1 }} />
      ) : (
        <Stack spacing={1} sx={{ mb: 2 }}>
          {props.comments.map((comm) => (
            <CommentItem
              key={comm.id}
              comm={comm}
              userAvatar={props.userAvatar}
              currentUserId={props.currentUserId}
              postOwnerId={props.postOwnerId}
              queryUsers={props.queryUsers}
              onCommentSubmit={props.onCommentSubmit}
              onCommentReaction={props.onCommentReaction}
              onCommentDelete={props.onCommentDelete}
            />
          ))}
        </Stack>
      )}

      {/* INPUT PRINCIPAL DE COMENTARIO */}
      <Stack direction="row" spacing={1} alignItems="flex-start">
        <Avatar src={props.userAvatar} sx={{ width: 32, height: 32 }} />
        <Box sx={{ flexGrow: 1, bgcolor: "#f0f2f5", borderRadius: 3, p: "2px" }}>
          <MentionsInput
            value={props.mainCommentText || ""} 
            onChange={(e) => props.setMainCommentText(e.target.value)}
            style={mentionsStyleComments}
            placeholder="Escribe un comentario..."
            allowSuggestionsAboveCursor={true}
          >
            <Mention
              trigger="@"
              data={handleDataFetch}
              markup="@[__display__](__id__)"
              displayTransform={(id, display) => `@${display}`}
              style={{ backgroundColor: "#D1E7FF" }}
            />
          </MentionsInput>
        </Box>
        <IconButton
          onClick={handleMainSubmit}
          sx={{ color: "#1877f2" }}
          disabled={!props.mainCommentText || !props.mainCommentText.trim()}
        >
          <Send fontSize="small" />
        </IconButton>
      </Stack>
    </Box>
  );
};

export default PostCommentsSection;